import { FieldType, ParamsBuilder } from "../types";
import { CheckboxBuilder } from "./checkbox";
import { DatetimeBuilder } from "./datetime";
import { DateMonthBuilder } from "./datemonth";
import { DropdownBuilder } from "./dropdown";
import { JSONBuilder } from "./json";
import { LookupBuilder } from "./lookup";
import { NumberBuilder } from "./number";
import { TextBuilder } from "./text";
import { UUIDBuilder } from "./uuid";

export function getBuilder(fieldType: FieldType): ParamsBuilder {
  switch (fieldType) {
    case "text":
      return new TextBuilder();
    case "number":
      return new NumberBuilder();
    case "date":
      return new DatetimeBuilder();
    case "datetime":
      return new DatetimeBuilder();
    case "datemonth":
      return new DateMonthBuilder();
    case "checkbox":
      return new CheckboxBuilder();
    case "dropdown":
      return new DropdownBuilder();
    case "lookup":
      return new LookupBuilder();
    case "uuid":
      return new UUIDBuilder();
    case "json":
      return new JSONBuilder();
  }
}
